import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { ActionItemDetailDto, FetchError, queryKeys, useAccessToken } from "src/http";

const useGetActionItemDetailRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getActionItemDetailRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.actionItems.detail>>): Promise<ActionItemDetailDto> {
    const accessToken = await getAccessToken();
    const [{ guid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/action-items/${guid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getActionItemDetailRequest };
};

const useGetActionItemDetail = (guid: string | undefined) => {
  const { getActionItemDetailRequest } = useGetActionItemDetailRequest();

  return useQuery({
    queryKey: queryKeys.actionItems.detail(guid),
    queryFn: getActionItemDetailRequest,
    enabled: guid !== undefined,
  });
};

export { useGetActionItemDetail };
